// Centralized API base URL helper
// In development, default to "/api" so CRA proxy forwards to backend.
// In production, set REACT_APP_API_BASE (e.g., https://api.example.com/api or /api when reverse-proxied).

import { getCurrentUserDepartment } from "../utils/userUtils";

const rawBase = (process.env.REACT_APP_API_BASE || "/api").trim();
export const API_BASE_URL = rawBase.endsWith("/") ? rawBase.slice(0, -1) : rawBase;

export const buildUrl = (path = "") => {
  if (!path) return API_BASE_URL;
  return `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

/**
 * Get user department for API calls
 * Throws error if session is invalid - DO NOT fallback to UEU
 * 
 * @returns {string} User's department (uppercase)
 * @throws {Error} If user is not logged in or department is missing
 */
export const getUserDepartment = () => {
  return getCurrentUserDepartment(); // Throws if missing
};

/**
 * Create standard headers with department
 * @returns {Object} Headers object with X-User-Department
 */
export const createDepartmentHeaders = () => {
  const department = getUserDepartment();
  return {
    "X-User-Department": department,
    "X-Bahagian-Pemantau": department // For backward compatibility
  };
};

export default API_BASE_URL;

